import React from "react";
import "../css/SubPage/SubPage.css";

const SectionCard = ({
  title,
  subtitle,
  description,
  children,
  website,
  websiteUrl,
}) => {
  return (
    <div className="main-section">
      <div className="main-text">
        {title && (
          <p className="chapter-title">
            <strong>{title}</strong>
          </p>
        )}

        {subtitle && (
          <p className="chapter-sub-title">
            <strong>{subtitle}</strong>
          </p>
        )}

        {description && <p className="chapter-description">{description}</p>}

        {children}

        {website && websiteUrl && (
          <ul className="bullet-point-list">
            <li className="bullet-point">
              <strong>Website:</strong>
              <a href={websiteUrl} className="link">
                {" "}
                {website}
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default SectionCard;
